<script setup lang="ts">
import IconOpenInNew from '~icons/material-symbols/open-in-new'

const { t } = useI18n()

const toogleElectricityBill = ref(false)
function openModalCep() {
  toogleElectricityBill.value = true
}
</script>

<template>
  <div class="text-brand-secondary-dark flex gap-1 cursor-pointer hover:underline items-center" @click="openModalCep">
    <span class="text-3xs">{{ t('simulation.newPage.client_data.form.bill_value.title_modal') }}</span>
    <IconOpenInNew />
  </div>

  <SolModal
    id="electricity-bill"
    :is-open="toogleElectricityBill"
    :title="t('simulation.newPage.client_data.form.bill_value.title_modal')"
    :action-primary-text="t('form.cepModal.titleButton')"
    :size="{
      desktop: 'large',
      mobile: 'bottom-sheet',
    }"
    @close="toogleElectricityBill = false"
    @action:primary="toogleElectricityBill = false"
  >
    <div>
      <div>
        <span class="font-bold">{{ t('simulation.newPage.client_data.form.bill_value.description_modal') }}</span>
        <ul class="list-disc pl-4">
          <li class="item mt-2">
            {{ t('simulation.newPage.client_data.form.bill_value.description_modal_item1') }}
          </li>
          <li class="item">
            {{ t('simulation.newPage.client_data.form.bill_value.description_modal_item2') }}
          </li>
          <li class="item">
            {{ t('simulation.newPage.client_data.form.bill_value.description_modal_item3') }}
          </li>
          <li class="item">
            {{ t('simulation.newPage.client_data.form.bill_value.description_modal_item4') }}
          </li>
        </ul>
      </div>
    </div>
  </SolModal>
</template>

<style lang="scss" scoped>
.item {
  @apply text-neutral-low-light;
}
</style>
